const common = {
  // Navbar
  'nav.home': '物件一覧',
  'nav.services': 'サービス',
  'nav.howItWorks': '購入の流れ',
  'nav.returns': '収益シミュレーション',
  'nav.honestFAQ': '正直なFAQ',
  'nav.properties': '物件',
  'nav.coOwnership': '共同保有',
  'nav.regions': 'エリアガイド',
  'nav.about': '会社概要',
  'nav.contact': 'お問い合わせ',
  'nav.requestList': '物件リストを請求',
  'nav.langJa': '日本語',
  'nav.langEn': 'EN',

  // Footer
  'footer.description': '海外の買い主様向けに、日本の不動産を購入からリノベーション、運営まで一貫してサポート。日本語ができなくても、現地に来なくても、すべて英語で完結します。',
  'footer.navigate': 'サイトマップ',
  'footer.contact': 'お問い合わせ',
  'footer.office': '事務所',
  'footer.nagano': '長野県長野市',
  'footer.japan': '日本',
  'footer.email': 'メール',
  'footer.hours': '営業時間',
  'footer.weekdays': '月曜日 – 金曜日',
  'footer.disclaimerTitle': '免責事項：',
  'footer.disclaimerText': '掲載の収益シミュレーションは代表物件に基づく保守的な試算であり、実際の収益は立地、リノベーション範囲、許認可状況、市場環境により異なります。物件ごとに個別に試算を行っています。日本の不動産所有権は居住権やビザの取得を保証するものではありません。海外買い主はFEFTA報告および2026年の開示要件を順守する必要があります。NOREN株式会社は日本の宅地建物取引業者です。',
  'footer.copyright': '© {{year}} NOREN株式会社 All rights reserved.',
  'footer.privacy': 'プライバシーポリシー',
  'footer.terms': '利用規約',

  // Shared / Buttons
  'btn.viewDetails': '詳細を見る',
  'btn.requestList': '物件を見る',
  'btn.seeWhatWeDo': 'サービスを見る',
  'btn.submit': '送信する',
  'btn.explore': '共同保有物件を見る',
  'btn.getInTouch': 'お問い合わせ',
  'btn.clearFilters': 'フィルターをリセット',
  'btn.close': '閉じる',
  'btn.whatsapp': 'WhatsApp',
  'btn.requestFullDetails': '詳細資料を請求',
  'btn.bookCall': '30分無料相談を予約',
  'btn.openCoListing': '共同保有リストを開く',
  'btn.expressInterest': '参加意向を伝える',
  'btn.submitListingRequest': 'リスト登録を申請',
  'btn.registerInterest': '参加を登録',
  'btn.showAll': 'すべて表示',
  'btn.backToProperties': '物件一覧に戻る',

  // Shared labels
  'label.offMarket': '販売中',
  'label.representative': '代表画像',
  'label.price': '価格',
  'label.type': '種別',
  'label.location': '所在地',
  'label.region': 'エリア',
  'label.yearBuilt': '築年数',
  'label.area': '面積',
  'label.bedrooms': '{{count}} 居室',
  'label.units': '{{count}} 戸',
  'label.searchPlaceholder': '物件番号、エリア、キーワードで検索...',
  'label.sort': '並び替え',
  'label.filters': 'フィルター',
  'label.showing': '{{total}} 件中 {{count}} 件を表示',
  'label.noMatch': '該当する物件がありません。',
  'label.required': '必須項目です',
  'label.invalidEmail': 'メールアドレスが正しくありません',
  'label.maxChars': '最大500文字まで',
  'label.approx': '約',
  'label.allIn': 'トータル',
  'label.perShare': '1口あたり',
  'label.spotsLeft_one': '残り {{count}} 口',
  'label.spotsLeft_other': '残り {{count}} 口',
  'label.full': '満員',
  'label.cg': 'After・リノベーションCG',
  'label.current': 'Now・現状写真',
  'label.cgShort': 'After',
  'label.currentShort': 'Now',
  'label.of': '{{current}}/{{total}}',

  // Form options
  'option.select': '選択してください...',
  'option.us': 'アメリカ合衆国',
  'option.uk': 'イギリス',
  'option.ca': 'カナダ',
  'option.au': 'オーストラリア',
  'option.sg': 'シンガポール',
  'option.hk': '香港',
  'option.other': 'その他',
  'option.under1m': '100万円未満',
  'option.1mTo5m': '100万円～500万円',
  'option.5mTo10m': '500万円～1,000万円',
  'option.10mTo30m': '1,000万円～3,000万円',
  'option.over20m': '2,000万円以上',
  'option.rentalIncome': '賃貸収益・利回り重視',
  'option.personalUse': '居住＋不定期賃貸',
  'option.retirement': '定住・セカンドハウス',
  'option.portfolio': 'ポートフォリオ分散',
  'option.exploring': 'まだ検討中',
  'option.liveIn': '居住用',
  'option.renovation': 'リノベーション物件',
  'option.rental': '賃貸収益',
  'option.notSure': '未定',

  // Currency
  'currency.yen': '¥',
  'currency.usd': '$',

  // Property types
  'type.all': 'すべて',
  'type.kominka': '古民家',
  'type.detached': '一戸建て',
  'type.apartmentBlocks': 'アパート（一棟）',
  'type.condos': 'マンション（単室）',

  // Sort options
  'sort.priceAsc': '価格：安い順',
  'sort.priceDesc': '価格：高い順',
  'sort.yearDesc': '築年：新しい順',
  'sort.yearAsc': '築年：古い順',

  // WhatsApp
  'whatsapp.prefill': 'NORENさん、こんにちは。物件番号 {{id}}（{{headline}}）に興味があります。詳しい資料をいただけますか？',
  'whatsapp.btn': 'WhatsApp',

  // Co-ownership modal
  'co.modal.openTitle': '共同保有リストを開く',
  'co.modal.interestTitle': '参加意向登録：{{title}}',
  'co.modal.subtitle': 'NORENはマッチングボード・宅建業者です。資金の預かり、投資運用、収益保証は一切行いません。',
  'co.modal.guardrailTitle': '法的ガードレール',
  'co.modal.guardrailText': '共同保有者は各自の名義で持分を取得し、弁護士・税理士等と独自の契約書を締結してすべての条件を定め、リスク・紛争も各自で負うものとします。NORENの役割は不動産仲介および共同保有者の紹介に限定されます。',
  'co.modal.name': 'お名前',
  'co.modal.email': 'メールアドレス',
  'co.modal.country': '居住国',
  'co.modal.coOwnerCount': '共同保有者数',
  'co.modal.estimatedAllIn': 'トータル予算（円）',
  'co.modal.shareCalc': '1口あたりの概算：',
  'co.modal.shareCalcNote': '{{allIn}} ÷ {{count}} = {{share}}。あくまで目安です。',
  'co.modal.notes': '備考・希望条件',
  'co.modal.sharePreference': '希望持分',
  'co.modal.shareFull': '全口',
  'co.modal.shareHalf': '半口',
  'co.modal.shareQuarter': '4分の1口',
  'co.modal.shareFlexible': '相談したい',
  'co.modal.message': 'メッセージ',
  'co.modal.agreementText': 'NORENは資金の預かり、投資運用、収益保証を行わないこと、および共同保有者が独自に法的・税務のアドバイスを受ける必要があることを理解しました。',
  'co.modal.agreementError': '同意が必要です',
  'co.modal.successOpen': 'リスト登録申請を受け付けました',
  'co.modal.successInterest': '参加意向を登録しました',
  'co.modal.successText': '内容を確認のうえ、2営業日以内にご連絡いたします。現時点では料金は発生しません。',
  'co.modal.nameError': 'お名前を入力してください',
  'co.modal.emailError': 'メールアドレスを入力してください',
  'co.modal.emailInvalid': '正しいメールアドレスを入力してください',
  'co.modal.countryError': '居住国を入力してください',
  'co.modal.allInError': 'トータル予算を入力してください',
  'co.modal.countError': '共同保有者は2～5名で設定してください',
  'co.modal.preferenceError': '希望持分を選択してください',

  // Misc shared
  'misc.thankYou': 'ありがとうございます',
  'misc.responseTime': '2営業日以内に、試算付きの厳選リストをお送りします。',
  'misc.receivedInquiry': 'お問い合わせを受け付けました。48時間以内に厳選物件リストと次のステップをご案内いたします。',
};

export default common;